<template>
   <div class="footer">
       <div class="container footer-sections-container">
           <div class="col-md-2 col-xs-2 directional footers-logo">
               <div class="logo-div-footer">
                   <router-link class="content" to="/">
                       <img src="/src/assets/img/logo_whited.png">
                   </router-link>
               </div>
           </div>
           <div class="col-md-10 col-sm-10 links-container">
            <div class="col-md-8  col-sm-8 col-xs-8 directional useful-links">
                <div class="col-md-6  col-xs-6 links-list directional ">
                    <a><h4>منتجاتنا</h4></a>
                    <ul class="list">
                        <li v-for="item in sections" v-bind:key="item.Id">
                              <router-link :to="{ name: 'products', params: { section: item.Title } }"> {{ item.Title }} </router-link>
                        </li>
                      
                    </ul>
                </div>
                  <div class="col-md-6 col-xs-6 links-list directional">
                    <a><h4>حول الشركة</h4></a>
                    <ul class="list">
                        <li><router-link to="/join-us">انضم لنا</router-link></li>
                        <li><router-link to="/contact-us">اتصل بنا</router-link></li>
                        <li><router-link to="/technical-support">الدعم الفني</router-link></li>
                    </ul>
                </div>
           </div>
           <div class="col-md-4 col-sm-4 col-xs-4 directory subscribe-section center-col-direction-flex">
                <div class="footer-Email">
                    <h4>تواصل معنا</h4>
                </div>
                <ul class="contact-list">
                    <li><a href="mailto:info@beetronix.com" ><i class="far fa-envelope"></i>info@beetronix.com</a></li>
                    <li><a href="callto:00963-993-327-100"><i class="fas fa-phone"></i>00963-993-327-100</a></li>
                    <li><a href="callto:00963-212-664-228"><i class="fas fa-mobile"></i>00963-212-664-228</a></li>
                </ul>
                <ul class="footer-social">
                     <li>
                        <a href="https://www.facebook.com/beetronix/" class="fab fa-facebook-square"></a>
                    </li>
                    <li>
                        <a href="https://twitter.com/beetronix_sy" class="fab fa-twitter-square" ></a>
                    </li>
                     <li>
                        <a href="https://www.linkedin.com/company/beetronix/" class="fab fa-linkedin" ></a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/beetronix/" class="fab fa-instagram" ></a>
                    </li>
                </ul>
           </div>
           </div>
          
           <div class="container footer-rights">
                <div class="row" >
                    <div class="col-md-12 col-xs-12 directional">
                        <div class="f-rights ">
                        <div class="">جميع الحقوق محفوظة</div>
                         <div class="main-color">Beetronix</div> © {{ new Date().getFullYear() }}
                    </div>
                    </div>
                </div>
            </div>
       </div>
   </div>
</template>
<script>
export default {
    name:'PageFooter',
      data() {
            return {
                sections: [ ],
            }
        },

        mounted() {
            axios.get(apiHost + "/sections")
                .then((response) => {
                    this.sections = response.data;
                })
                .catch((error) => console.log(error));
        }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/page-footer.vue